<!-- START CONTENT -->
@if(testAccession) {
<section>
  <!--<div class="page-title">
    <div class="pull-left">
      <h1 class="title">Result Details</h1>
    </div>
  </div>-->
  <!-- START SEARCH RESULTS -->
  <div class="col-sm-12">
    <section class="box">
      <div class="content-body">
        <div class="row">
          <div class="col-sm-9"></div>

          <div class="col-sm-1">
            <button class="form-control" (click)="raiseHide($event)">X</button>
          </div>
          <div class="col-sm-1">
            <div class="dropdown">
              <i class="col-sm-1 fa fa-download fa-2x dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
              <!--<button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Download
              </button>-->
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" (click)="downloadJSON(testAccession)">
                  <i class="fa fa-file-code-o fa-2x"></i>
                </a>
                <a class="dropdown-item" (click)="downloadCSV(testAccession)">
                  <i class="fa fa-file-excel-o fa-2x"></i>
                </a>
                <a class="dropdown-item" (click)="downloadXML(testAccession)">
                  <i class="fa fa-file-text-o fa-2x"></i>
                </a>
                <a class="dropdown-item" (click)="print($event)">
                  <i class="fa fa-file-pdf-o fa-2x"></i>
                </a>
              </div>
            </div>
          </div>
          <i class="col-sm-1 fa fa-print fa-2x" (click)="print($event)"></i>
        </div>
        <div class="row">
          @if(cumClicked){
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-11"></div>
              <div class="col-sm-1">
                <button id="close-btn" class="form-control" (click)="hideCum($event)">X</button>
              </div>
            </div>
            <div class="row">
              <result-cumulative [cumulativeQuery]="cumulativeQuery"
                                 [shouldBeEmpty]="cumShouldBeEmpty">
              </result-cumulative>
            </div>
          </div>
          }
        </div>
        <div class="row">
          <div class="col-sm-12 margintop30 screen">
            <!--<div class="col-sm-11 col-sm-offset-1 margintop30">-->
            <div class="row underline header">
              <span class="col-sm-3">
                <label>Name: </label>
                @if(UserSource.Site == 'TRIALS') {
                <label>Subject: </label>
                }
                {{testAccession.Title}} {{testAccession.ForeName}} {{testAccession.Surname}}
              </span>
              <span class="col-sm-3"><label>D.O.B: </label> {{testAccession.Dob | date:'dd/MM/yyyy'}} | {{getAge()}} </span>
              <span class="col-sm-3"><label>Request Date: </label> {{testAccession.RequestDate | date:'dd/MM/yy HH:mm'}}</span>
              <span class="col-sm-3"><label>Lab Number: </label> {{testAccession.LabNumber}}</span>
              <span class="col-sm-3"><label>Sex: </label> {{testAccession.Sex}}</span>
              <span class="col-sm-3"> @if(UserSource.Site !== 'TRIALS'){<label>Attending Dr: </label>} @if(UserSource.Site == 'TRIALS'){<label>Vist/Timepoint: </label>} {{testAccession.AttendingDr}}</span>
              <span class="col-sm-3"><label>Sample Date: </label> {{testAccession.SampleDate | date:'dd/MM/yy HH:mm' }}</span>
              <span class="col-sm-3"><label>Report Date: </label> {{testAccession.ReportedDate | date:'dd/MM/yy HH:mm' }}</span>
              <span class="col-sm-3"><label>Reference: </label> {{testAccession.Reference}} | {{testAccession.HospitalNo}}</span>
              </div>
              <div class="row col-sm-12 margintop30">
                @for(testgroup of testAccession.Tests; track testgroup.TestCode) {
                <div class="resultgroup">
                  @if(testgroup.ResultLines.length > 0) {
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-sm-12 underline testheader">
                        <span class="courier"><strong>{{testgroup.TestName}}</strong></span>
                      </div>
                    </div>
                    <div class="table-striped resultlines">
                      @for(resultLine of testgroup.ResultLines; track resultLine.TestCode) {
                      <div class="row  col-sm-offset-1">
                        <span class="col-sm-2 courier">{{resultLine.TestName}}</span>
                        <i class="col-sm-1 fa fa-line-chart" (click)="cumViewClicked(resultLine.TestCode)"></i>
                        <pre class="col-sm-4 courier" [ngClass]="{'high' : resultLine.Flag == 'High', 'low' : resultLine.Flag == 'Low', 'abnorm' : resultLine.Flag == 'A'}">{{resultLine.Result}}</pre>
                        <i class="col-sm-1 high fa " [ngClass]="{ 'fa-arrow-up' : resultLine.Flag == 'High', 'fa-arrow-down' : resultLine.Flag == 'Low'}"></i>
                        <span class="col-sm-2 courier">{{resultLine.UOM}}</span>
                        <span class="col-sm-2 courier">{{resultLine.RangeText}}</span>
                      </div>
                      }
                    </div>
                  </div>
                  }
                </div>
                }
              </div>
            </div>
          <table class="report-container">
            <thead class="report-header">
              <tr>
                <th>
                  <div class="row underline header">
                    <div class="col-sm-1"><img alt="logo" src="/Images/apple-touch-icon-57-precomposed.png" /></div>
                    <span class="col-sm-3"> @if(UserSource.Site !== 'TRIALS'){<label>Patient Name: </label>} @if(UserSource.Site == 'TRIALS'){<label>Subject: </label>} {{testAccession.Title}} {{testAccession.ForeName}} {{testAccession.Surname}}</span>
                    <span class="col-sm-3"><label>DOB: </label> {{testAccession.Dob | date:'dd/MM/yyyy'}}</span>
                    <span class="col-sm-3"><label>Request: </label> {{testAccession.RequestDate | date:'dd/MM/yy HH:mm'}}</span>
                    <span class="col-sm-3"><label>Lab: </label> {{testAccession.LabNumber}}</span>
                    <span class="col-sm-3"><label>Sex: </label> {{testAccession.Sex}}</span>
                    <span class="col-sm-4"> @if(UserSource.Site !== 'TRIALS'){<label>Attending Dr: </label>} @if(UserSource.Site == 'TRIALS'){<label>Vist/Timepoint: </label>} {{testAccession.AttendingDr}}</span>
                    <span class="col-sm-3"><label>Sample: </label> {{testAccession.SampleDate | date:'dd/MM/yy HH:mm' }}</span>
                    <span class="col-sm-3"><label>Report: </label> {{testAccession.ReportedDate | date:'dd/MM/yy HH:mm' }}</span>
                    <span class="col-sm-3"><label>Ref: </label> {{testAccession.Reference}} | {{testAccession.HospitalNo}}</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="report-content">
              <tr>
                <td>
                  <div class="row col-sm-12 margintop30">
                    @for(testgroup of testAccession.Tests; track testgroup.TestCode) {
                    <div class="resultgroup">
                      @if(testgroup.ResultLines.length > 0) {
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-12 underline testheader">
                            <span class="courier"><strong>{{testgroup.TestName}}</strong></span>
                          </div>
                        </div>
                        <div class="table-striped resultlines">
                          @for(resultLine of testgroup.ResultLines; track resultLine.TestCode) {
                          <div class="row  col-sm-offset-1">
                            <span class="col-sm-2 courier">{{resultLine.TestName}}</span>
                            <i class="col-sm-1 fa fa-line-chart" (click)="cumViewClicked(resultLine.TestCode)"></i>
                            <pre class="col-sm-4 courier" [ngClass]="{'high' : resultLine.Flag == 'High', 'low' : resultLine.Flag == 'Low'}">{{resultLine.Result}}</pre>
                            <i class="col-sm-1 high fa " [ngClass]="{ 'fa-arrow-up' : resultLine.Flag == 'High', 'fa-arrow-down' : resultLine.Flag == 'Low'}"></i>
                            <span class="col-sm-2 courier">{{resultLine.UOM}}</span>
                            <span class="col-sm-2 courier">{{resultLine.RangeText}}</span>
                          </div>
                          }
                        </div>
                      </div>
                      }
                    </div>
                    }
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot class="report-footer overline">
              <tr><td><span class="col-sm-12 courier">Authorised By: Clinical Pathology, TDL</span></td></tr>
            </tfoot>
          </table>
        </div>
      </div>
    </section>
  </div>
</section>
}
